<template>
  <BreadCrumb class="hidden sm:block" />
  <MarketingPage v-if="entry" :entry="entry" :social-media-accounts="socialMediaAccounts" />
</template>

<script>
import gql from 'graphql-tag';
import { SeomaticFragment, EntryPageFragment } from '@/mixins/entryPage';
import MarketingPage, { HomePageFragment } from '@/components/marketing/MarketingPage';
import { SocialMediaAccountsFragment } from '@/components/layout/footer/SocialMediaAccounts';
import { useEntryPage } from '@/composables/useEntryPage';
import BreadCrumb from '@/components/layout/BreadCrumb';

export const HomePageQuery = gql`
  query HomePageQuery($site: String!, $uri: String!) {
    entry(section: "home", site: [$site]) {
      ...EntryPageFragment
      ...HomePageFragment
    }

    socialSet: globalSet(site: [$site], handle: "socialMediaAccounts") {
      ...SocialMediaAccountsFragment
    }

    seomatic(site: $site, uri: $uri, asArray: true) {
      ...SeomaticFragment
    }
  }

  ${EntryPageFragment}
  ${HomePageFragment}
  ${SeomaticFragment}
  ${SocialMediaAccountsFragment}
`;

export default defineNuxtComponent({
  name: 'Homepage',

  components: { MarketingPage, BreadCrumb },

  async asyncData() {
    const { $i18n, $craftRequest } = useNuxtApp();
    const { locale } = $i18n;

    const uri = '__home__'; // home uri by craft convention

    const variables = { site: locale.value, uri };

    const {
      entry,
      seomatic,
      socialSet: { socialMediaAccounts },
    } = await $craftRequest(HomePageQuery, variables);

    return { entry, seomatic, socialMediaAccounts };
  },

  data() {
    return { socialMediaAccounts: [], entryPage: null };
  },

  created() {
    this.entryPage = useEntryPage(this.entry, this.seomatic);
  },
});
</script>
